import { render } from "./Leaderboards.vue?vue&type=template&id=f7c431f6&ts=true"
import script from "./Leaderboards.vue?vue&type=script&lang=ts"
export * from "./Leaderboards.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__